import type { ReactNode } from 'react';
import { DesktopWorkshop } from './DesktopWorkshop';
import { MobileTabs } from './MobileTabs';
import { useMediaQuery } from '@app/hooks/useMediaQuery';

export function ResponsiveShell({ children }: { children: ReactNode }) {
  const desktop = useMediaQuery('(min-width: 1024px)');
  return desktop ? (
    <DesktopWorkshop>{children}</DesktopWorkshop>
  ) : (
    <MobileTabs>{children}</MobileTabs>
  );
}
